
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {EndorsementModel, EndorsementPositionModel, PositionModel} from "@/api-client";
    import {BvTableFieldArray} from "bootstrap-vue";

    @Component
    export default class Endorsement extends Vue{
        @Prop({required: true})
        document!: EndorsementModel;

        tableFields: BvTableFieldArray = [
            {
                key: "name",
                label: this.$ls.Documents_Query_Table_Label_Position,
                sortable: false,
                thClass: "w-50",
            },
            {
                key: "restrictions",
                label: this.$ls.Documents_Query_Table_Label_Restrictions,
                sortable: false,
                thClass: "w-50",
                formatter: (value: any, key: any, item: PositionModel) => item.restrictions.length > 0 ? item.restrictions.join(", ") : "Ei ole"
            },
        ];
    }
